export enum BillingPeriodUnit {
    Day = 'day',
    Week = 'week',
    Month = 'month',
    Year = 'year'
}

export enum BillingPlatformSubscriptionStatus {
    Future = 'future',
    Trial = 'in_trial',
    Active = 'active',
    Paused = 'paused',
    NonRenewing = 'non_renewing',
    Cancelled = 'cancelled'
}

export enum PaymentSourceRole {
    Primary = 'primary',
    Backup = 'backup',
    None = 'none'
}

export enum PaymentSourceType {
    Card = 'card'
}

export enum PaymentSourceStatus {
    Valid = 'valid',
    Expiring = 'expiring',
    Expired = 'expired',
    Invalid = 'invalid'
}

export enum BillingPlatformInvoiceStatus {
    Paid = 'paid',
    PaymentDue = 'payment_due',
    NotPaid = 'not_paid'
}

export enum TransactionStatus {
    InProgress = 'in_progress',
    Success = 'success',
    Voided = 'voided',
    Failure = 'failure',
    Timeout = 'timeout',
    NeedsAttention = 'needs_attention'
}

export enum TransactionType {
    Authorization = 'authorization',
    Payment = 'payment',
    Refund = 'refund',
    PaymentReversal = 'payment_reversal'
}

export enum TransactionFraudFlag {
    Safe = 'safe',
    Suspicious = 'suspicious',
    Fraudulent = 'fraudulent'
}

export enum BillingCardFieldName {
    Number = 'number',
    Expiry = 'expiry',
    CVV = 'cvv'
}
